/**
 * 로그인 식별자(`아이디@회사코드`) 입력 보조.
 *
 * 이메일로는 로그인할 수 없고 개인=아이디 한 칸, 기업=아이디+회사코드 두 칸을
 * 받는다. 두 칸으로 쪼갠 이유가 "이메일과 눈으로 구분되게" 이므로, 사용자가 한 칸에
 * 통째로 친 경우를 여기서 판정해 화면이 안내나 분해로 처리한다.
 */

/** 이메일 형식 감지 — 서버에 보내기 전에 FE 에서 안내를 띄우기 위한 판정. */
export const EMAIL_SHAPED = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * `odin@howcost` 처럼 통째로 붙여넣은 값을 두 칸으로 나눈다.
 * 나눌 수 없으면 null — 이메일이거나 `@` 한쪽이 비었거나 도메인 형태인 경우다.
 * 도메인(`.` 포함)을 회사코드로 넘기지 않는 것은 회사코드에 `.` 이 올 수 없어서다.
 */
export function splitLoginIdentifier(
  value: string,
): { loginId: string; orgSlug: string } | null {
  const trimmed = value.trim().toLowerCase();
  if (EMAIL_SHAPED.test(trimmed)) return null;

  const at = trimmed.indexOf('@');
  if (at <= 0 || at === trimmed.length - 1) return null;

  const loginId = trimmed.slice(0, at);
  const orgSlug = trimmed.slice(at + 1);
  if (orgSlug.includes('@') || orgSlug.includes('.')) return null;

  return { loginId, orgSlug };
}

/** 회사코드 입력 정규화 — 백엔드 ORG_SLUG_REGEX(`[a-z0-9]`) 밖의 문자는 버린다. */
export function sanitizeOrgSlug(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]/g, '');
}

/**
 * 로그인 아이디 칸 정규화 — 소문자로 바꾸고 영문·숫자·`_`·`@`·`.` 밖의 문자(한글 포함)는 버린다.
 */
export function sanitizeLoginIdentifier(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9_@.]/g, '');
}

/** 아이디 입력 정규화 — 백엔드 LOGIN_ID_LOCAL_REGEX(`[a-z0-9_]`) 밖의 문자는 버린다. */
export function sanitizeLoginId(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9_]/g, '');
}
